import { useEntity } from '@backstage/plugin-catalog-react';
import { Features } from '../types';

export const useAccountFeatures = (): Features => {
  const { entity } = useEntity();
  return entity.spec?.features as Features;
};
